import React from "react";
import Header from "./Header";
interface DelegateUserLayoutProps {
  children: React.ReactNode;
}
const DelegateUserLayout: React.FC<DelegateUserLayoutProps> = (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100vh",
      }}
    >
      <Header />
      {props.children}
    </div>
  );
};

export default DelegateUserLayout;
